import { Component, type ErrorInfo, type ReactNode } from "react";
import { useLanguage } from "../contexts/LanguageContext";

class ErrorBoundaryInner extends Component<
  {
    children: ReactNode;
    title: string;
    description: string;
    reload: string;
  },
  { failed: boolean }
> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("ui_boundary", {
      message: error.message,
      stack: info.componentStack,
    });
  }
  render() {
    return this.state.failed ? (
      <main className="page container">
        <div className="panel empty">
          <h1>{this.props.title}</h1>
          <p className="muted">{this.props.description}</p>
          <button className="button primary" onClick={() => location.reload()}>
            {this.props.reload}
          </button>
        </div>
      </main>
    ) : (
      this.props.children
    );
  }
}

export function ErrorBoundary({ children }: { children: ReactNode }) {
  const { t } = useLanguage();
  return (
    <ErrorBoundaryInner
      title={t({
        tr: "Bir şeyler sessizliğe gömüldü.",
        en: "Something went quiet.",
      })}
      description={t({
        tr: "Çalışma alanını geri getirmek için sayfayı yenileyin.",
        en: "Reload the page to restore the workspace.",
      })}
      reload={t({ tr: "Yenile", en: "Reload" })}
    >
      {children}
    </ErrorBoundaryInner>
  );
}
